class Controller {
  constructor(Events, Sections, $stateParams, District, DistrictTransforms) {
    "ngInject";

    this.Events = Events;
    this.District = District;
    this.$stateParams = $stateParams;
    this.sections = Sections.settingsSections;
    this.DistrictTransforms = DistrictTransforms;

    this.onUpdate = this.Events.getUpdateEvent("district");
  }
  $onInit() {
    const showNotificationEvent = this.Events.eventsType
      .onShowSuccessNotification;
    const errorEvent = this.Events.eventsType.onShowErrorNotification;
    const onUpdate = (item) => {
      const updatedItem = {};
      let request;
      updatedItem[item.key] =
        typeof item.value !== "undefined"
          ? item.value
          : item.name
          ? item.name._id
          : null;

      if (item.methodName) {
        request = this.District.updateAction(
          this.$stateParams.id,
          item.methodName,
          updatedItem
        ).$promise;
      } else {
        request = this.District.update(this.$stateParams.id, updatedItem)
          .$promise;
      }

      request.then(() => {
        this.district[item.key].isDisabled = true;
        this.Events.emit(showNotificationEvent, {
          message: `Your district "${item.key}" has been updated successfully`,
        });
      });
    };

    this.District.get(this.$stateParams.id).$promise.then(
      (response) => {
        this.district = this.DistrictTransforms.justify(response);
      },
      (response) => this.Events.emit(errorEvent, response.data)
    );

    this.Events.on(this.onUpdate, onUpdate);
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/district/district.controller.js